<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1 style="padding-top:100px;">About the Author</h1>
<p>Antonina Irena Brzozowska was born, grew up and was educated in the north of England. Coming from Polish extraction, she has a strong interest in the culture and traditions of Poland. Currently, a supply teacher she has taken immense pleasure in writing, reading and travelling.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?6010fb0b